import React from 'react';

import AppBar from 'ha/ui/next/AppBar';
import Toolbar from 'ha/ui/next/Toolbar';
import Grid from 'ha/ui/next/Grid';
import Divider from 'ha/ui/next/Divider';

import NavBarLogo from './NavBarLogo';

export const AppBarMobile: React.FC = ({ children }) => {
  return (
    <AppBar
      elevation={0}
      position="static"
      color="inherit"
      data-test-locator="NavBar Top Mobile"
    >
      <Toolbar>
        <Grid alignItems="center" justify="space-between" container>
          <Grid item>
            <NavBarLogo />
          </Grid>
          <Grid item>{children}</Grid>
        </Grid>
      </Toolbar>
      <Divider />
    </AppBar>
  );
};

export default AppBarMobile;
